import http from "./index.js"
// 导航接口
export function getNav(params) {

    return http({
        method: "get",
        url: '/WebChannelCommonController/getAllSonMenus',
        params,
    })
}
// 文章接口
export function getDocList(params) {
    return http({
        method: "get",
        url: '/CommonController/common/getDocListByUid',
        params,
    })
}
// 文章过滤
export function getDocListByAttr(params) {
    return http({
        method: "get",
        url: '/SEIDocController/getDocsByUidAndAttr',
        params,
    })
}
export function getDocListByAttrForUids(params) {
    return http({
        method: "get",
        url: '/CommonController/common/docByWebChannel',
        params,
    })
}
// 词云
export function getWordAir(params) {
    return http({
        method: "get",
        url: '/SEIDocController/wordsByWebChannels',
        params,
    })
}
export function getNewWordAir(params) {
    return http({
        method: "get",
        url: '/CommonController/common/getHotWordsByType',
        params,
    })
}

export function searchWordForTitle(params) {
    return http({
        method: "get",
        url: '/CommonController/common/docByWebChannelAndKeyWords',
        params,
    })
}


export function getHotColumn(params) {
    return http({
        method: "get",
        url: '/CommonController/common/getMenuByUid',
        params,
    })
}

// 文章详情页
export function DRCNETSearch(data){
    return http({
        method: "post",
        url: 'https://search.drcnet.com.cn/search/getSearchString/',
        data,
    })
}